import { IState } from '../../../store';
import { getOfferType, FOfferType } from '../../../utils/offer_type';
import { getIsFromSeller } from '../../newObject';

/** Новостройка от представителя */
export function isNewbuildingFromSellerSelector(state: IState) {
  const isFromSeller = getIsFromSeller(state);
  const { offer } = state.offerData;
  const offerType = getOfferType(offer);

  return isFromSeller && offerType === FOfferType.FlatNew;
}
